import React, { useEffect, useState } from "react";
import { authFetch } from "../utils/authFetch";

function getError(data) {
  if (typeof data?.detail === "string") return data.detail;
  if (typeof data?.error === "string") return data.error;
  if (data && typeof data === "object") {
    return Object.entries(data)
      .map(([key, value]) =>
        `${key}: ${Array.isArray(value) ? value.join(", ") : String(value)}`
      )
      .join(" | ");
  }
  return "Impossibile salvare il metodo di pagamento.";
}

export default function B2BPaymentSelector({
  ordine,
  onUpdated,
  disabled = false,
}) {
  const [choice, setChoice] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const [message, setMessage] = useState("");

  const savedMethod = ordine?.payment_method || "";

  useEffect(() => {
    setChoice(
      ["ONLINE", "CONSEGNA"].includes(savedMethod)
        ? savedMethod
        : ""
    );
  }, [ordine?.id, savedMethod]);

  if (!ordine) return null;

  const editable =
    ordine.status === "DRAFT" &&
    !ordine.b2b_signed_at &&
    !ordine.is_paid &&
    !disabled;

  const validSavedMethod =
    savedMethod === "ONLINE" || savedMethod === "CONSEGNA";

  const changed = choice !== savedMethod;

  async function save() {
    if (!editable || busy || !choice || !changed) return;

    setBusy(true);
    setError("");
    setMessage("");

    try {
      const response = await authFetch(
        `/api/ordini/${encodeURIComponent(ordine.id)}/`,
        {
          method: "PATCH",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ payment_method: choice }),
        }
      );

      const data = await response.json().catch(() => ({}));

      if (!response.ok) throw new Error(getError(data));

      if (typeof onUpdated !== "function") {
        throw new Error(
          "Metodo salvato, ma il riepilogo non può aggiornarsi. Ricarica la pagina."
        );
      }

      await onUpdated();
      setMessage("Metodo di pagamento salvato.");
    } catch (err) {
      setError(err.message || "Errore salvataggio pagamento.");
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="card rounded-4 shadow-sm mb-3">
      <div className="card-body">
        <h5 className="fw-bold mb-3">Metodo di pagamento</h5>

        {validSavedMethod && (
          <div className="alert alert-info">
            Metodo attualmente salvato:{" "}
            <strong>
              {savedMethod === "ONLINE"
                ? "Online con Stripe"
                : "Alla consegna (contanti o POS)"}
            </strong>
          </div>
        )}

        {editable && (
          <>
            <label
              className="form-label"
              htmlFor={`b2b-payment-${ordine.id}`}
            >
              Scegli come pagare
            </label>

            <select
              id={`b2b-payment-${ordine.id}`}
              className="form-select mb-3"
              value={choice}
              disabled={busy}
              onChange={(event) => {
                setChoice(event.target.value);
                setMessage("");
                setError("");
              }}
            >
              <option value="">Seleziona un metodo</option>
              <option value="ONLINE">Online con Stripe</option>
              <option value="CONSEGNA">
                Alla consegna (contanti o POS)
              </option>
            </select>

            <button
              type="button"
              className="btn btn-outline-primary w-100"
              disabled={busy || !choice || !changed}
              onClick={save}
            >
              {busy ? "Salvataggio..." : "Salva metodo di pagamento"}
            </button>
          </>
        )}

        {error && (
          <div className="alert alert-danger mt-3" role="alert">
            {error}
          </div>
        )}

        {message && (
          <div className="alert alert-success mt-3" role="status">
            {message}
          </div>
        )}

        <p className="text-muted small mt-3 mb-0">
          Online: l'ordine viene inviato alla SEDE soltanto
          dopo la conferma del pagamento Stripe.
          Alla consegna: pagamento in contanti o POS,
          da registrare al momento dell'incasso.
        </p>
      </div>
    </div>
  );
}
